
import { format, isValid, parse } from 'date-fns';

/**
 * Format date for display in text inputs
 */
export const formatDateForInput = (date: Date | null): string => {
  if (!date || !isValid(date)) return '';
  return format(date, 'MM/dd/yyyy');
};

/**
 * Parse date from text input
 */
export const parseDateFromInput = (dateString: string): Date | null => {
  if (!dateString) return null;
  try {
    const parsedDate = parse(dateString, 'MM/dd/yyyy', new Date());
    return isValid(parsedDate) ? parsedDate : null;
  } catch (error) {
    return null;
  }
};

/**
 * Check if input matches date format MM/DD/YYYY
 */
export const isValidDateFormat = (value: string): boolean => {
  const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  return datePattern.test(value);
};
